import { MenuStage } from './menu-stage-model';
import { RecipeStep } from  './recipe-step-model';
import { RecipeIngredient } from './recipe-component-model';

export class Recipe {
    CalculationWeight: number;
    CalorificValue: number;
    Carbohydrates: number;
    CategoryName: string;
    Cost: number;
    Description: string;
    Fats: number;
    FavoriteComment: string;
    FullCategory: string;
    FullName: string;
    RecipeName: string;
    Id_Category: number;
    Id_Owner: number;
    Id_Recipe: number;
    Id_Stage: number;
    GarbageWeight: number;
    Image: string;
    ImageSize = null;
    ImagePath: string;
    PreviousImagePath: string;
    ImageFile: File;
    IsFavorite: boolean;
    IsOwn: boolean;
    IsUsed: boolean;
    IsXcluded: boolean;
    MPek: boolean;
    Micro: boolean;
    Multi: boolean;
    Proteins: number;
    RatingFavorite: number;
    RatingMenu: number;
    RecipeGroup: string;
    Simple: number;
    Source: string;
    SubCategoryName: string;
    TimeFrom: string;
    TimeLastModifed: string;
    XcludedComment: string;
    Quality: number;
    StateForChange: number;
    StageId: number;
    Ingredients: RecipeIngredient[];
    IngredientsWeight: number;
    IsImageUpdated = false;
    ImageToShow: string;
    // Признак "сырого" рецепта, используется для разделения логики при перетаскивании меню из списка рецептов и других приёмов пищи
    IsRaw = false;
    RecipeChanged = 0;
    Stages: RecipeStep[];
    CurrentMenuWeight: number;
    IsPrint: boolean;
    portion: number;
    CommentsNum: number;
    RatingVoteValue: number;
    TypeMenu: number;
    SingleN_Part: number;

    /**Получение объекта Recipe из объекта MenuStage */
    public static convertFromMenuStage(menu: MenuStage): Recipe {
        const recipe = new Recipe();
        recipe.Id_Recipe = menu.Id_Recipe;
        recipe.FullName = menu.RecipeName;
        recipe.RecipeName = menu.RecipeName;
        recipe.StageId = menu.Id_Stage;
        recipe.RecipeChanged = menu.RecipeChanged;
        recipe.CalorificValue = menu.CalorificValue;
        recipe.Proteins = menu.Proteins;
        recipe.Fats = menu.Fats;
        recipe.Carbohydrates = menu.Carbohydrates;
        recipe.CalculationWeight = menu.CalculationWeight;

        return recipe;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-model.ts